module.exports = __webpack_public_path__ + "static/media/Low-Power-Displays-Image-2.8d4d6dd4.jpeg";